import { useQuery } from '@tanstack/react-query';
import { regionService, 
  type GetAllRegionsResponse 
} from '../services/regionService';

export { regionService };

// Get all regions
export function useGetAllRegions(enabled = true) {
  return useQuery({
    queryKey: ['regions', 'all'],
    queryFn: async () => {
      const res = await regionService.getAllRegions();
      return res.responseValue as GetAllRegionsResponse;
    },
    enabled,
  });
}
